<mat-card class="error-card">
    <mat-card-content>
        <h2>We're sorry but you are not authorized to use this application.</h2>
        <h2>Please submit a helpdesk ticket for access.</h2>
    </mat-card-content>
</mat-card>